import { ImagePaths } from '../../lib/imageUrls.js';
import { securityFundamentals } from './security-fundamentals.js';
import { microsoftActiveDirectoryFundamentals } from './microsoft-active-directory-fundamentals.js';
import { complianceGovernance } from './compliance-governance.js';
import { cloudSecurityArchitect } from './cloud-security-architect.js';
import { essentialEightFundamentals } from './essential-eight-fundamentals.js';
import { microsoft365Security } from './microsoft-365-security.js';
import { essentialEightAssessmentCourse } from './essential-eight-assessment-course.js';
import { microsoftActiveDirectoryAdministration } from './microsoft-active-directory-administration.js';
import { cissp } from './cissp.js';
import { aiForFamilies } from './ai-for-families.js';
import { aiForBusiness } from './ai-for-business.js';
import { aiGovernanceRiskCompliance } from './ai-governance-risk-compliance.js';
import { aiMasterPromptEngineering } from './ai-master-prompt-engineering.js';
import { ai901AzureAiFundamentals } from './ai-901-azure-ai-fundamentals.js';
import { ai200AzureAiDeveloperAssociate } from './ai-200-azure-ai-developer-associate.js';
import { smbCybersecurityEssentials } from './smb-cybersecurity-essentials.js';
import { smbIncidentResponsePlaybook } from './smb-incident-response-playbook.js';
import { smbCybersecurityAwareness } from './smb-cybersecurity-awareness.js';
import { smbCybersecurityRiskAwarenessWorkshop } from './smb-cybersecurity-risk-awareness-workshop.js';
import { smbCybersecurityDataProtectionStrategies } from './smb-cybersecurity-data-protection-strategies.js';
import { ai300MlOpsEngineerAssociate } from './ai-300-ml-ops-engineer-associate.js';
import { sc500CloudAndAiSecurityEngineer } from './sc-500-cloud-and-ai-security-engineer.js';
import { sharepointCopilotInADay } from './sharepoint-copilot-in-a-day.js';
import { sharepointSiteOwners } from './sharepoint-site-owners.js';
import { sharepointSiteMembers } from './sharepoint-site-members.js';
import { sharepointInformationArchitect } from './sharepoint-information-architect.js';
import { sharepointCopilotReadinessFoundation } from './sharepoint-copilot-readiness-foundation.js';
import { copilotFoundationsWave12 } from './copilot-foundations-wave-1-2.js';
import { copilotWave3AgenticAi } from './copilot-wave-3-agentic-ai.js';
import { copilotGovernanceCompliance } from './copilot-governance-compliance.js';
import { copilotSecurityRoadmapEssentialEight } from './copilot-security-roadmap-essential-eight.js';
import { sc300IdentityAccessAdministrator } from './sc-300-identity-access-administrator.js';
import { conditionalAccessWorkshop } from './conditional-access-workshop.js';
import { securingActiveDirectory } from './securing-active-directory.js';
import { hybridIdentityWorkshop } from './hybrid-identity-workshop.js';
import { smbEssentialEightStarter } from './smb-essential-eight-starter.js';
import { cyberWardensUplift } from './cyber-wardens-uplift.js';
import { purviewRetentionAtScale } from './purview-retention-at-scale.js';
import { purviewForCopilot } from './purview-for-copilot.js';
import { purviewInADayExecutive } from './purview-in-a-day-executive.js';
import { purviewDataProtectionPractitioners } from './purview-data-protection-practitioners.js';
import { purviewInsiderRiskCommsCompliance } from './purview-insider-risk-comms-compliance.js';
import { purviewEnterpriseArchitecture } from './purview-enterprise-architecture.js';
import { purviewEndpointSecurity } from './purview-endpoint-security.js';
import { purviewCommunicationCompliance } from './purview-communication-compliance.js';
import { aiForFinanceM365 } from './ai-for-finance-m365.js';
import { aiForHealthcareM365 } from './ai-for-healthcare-m365.js';
import { aiForHrM365 } from './ai-for-hr-m365.js';
import { aiForAccountingM365 } from './ai-for-accounting-m365.js';
import { aiForLogisticsM365 } from './ai-for-logistics-m365.js';
import { sc100CybersecurityArchitectExpert } from './sc-100-cybersecurity-architect-expert.js';
import { sc200SecurityOperationsAnalyst } from './sc-200-security-operations-analyst.js';
import { sc400InformationProtectionAdministrator } from './sc-400-information-protection-administrator.js';
import { ms102Microsoft365Administrator } from './ms-102-microsoft-365-administrator.js';
import { detectingActiveDirectoryCompromise } from './detecting-active-directory-compromise.js';
import { entraIdHardeningIdentityProtection } from './entra-id-hardening-identity-protection.js';
import { defenderForCloudAppsSessionPolicies } from './defender-for-cloud-apps-session-policies.js';

// AI Quick Start family — September 2026 cohort (#317).
// Free-with-code lead magnet feeding three role-specific four-hour courses.
import { promptEngineeringBasics } from './prompt-engineering-basics.js';
import { aiQuickStartHr } from './ai-quick-start-hr.js';
import { aiQuickStartExecutiveAssistants } from './ai-quick-start-executive-assistants.js';
import { aiQuickStartSmallBusiness } from './ai-quick-start-small-business.js';

// Build coursesData object (keyed by slug) - same structure as before
export const coursesData = {
  [securityFundamentals.slug]: securityFundamentals,
  [microsoftActiveDirectoryFundamentals.slug]: microsoftActiveDirectoryFundamentals,
  [complianceGovernance.slug]: complianceGovernance,
  [cloudSecurityArchitect.slug]: cloudSecurityArchitect,
  [essentialEightFundamentals.slug]: essentialEightFundamentals,
  [microsoft365Security.slug]: microsoft365Security,
  [essentialEightAssessmentCourse.slug]: essentialEightAssessmentCourse,
  [microsoftActiveDirectoryAdministration.slug]: microsoftActiveDirectoryAdministration,
  [cissp.slug]: cissp,
  [aiForFamilies.slug]: aiForFamilies,
  [aiForBusiness.slug]: aiForBusiness,
  [aiGovernanceRiskCompliance.slug]: aiGovernanceRiskCompliance,
  [aiMasterPromptEngineering.slug]: aiMasterPromptEngineering,
  [ai901AzureAiFundamentals.slug]: ai901AzureAiFundamentals,
  [ai200AzureAiDeveloperAssociate.slug]: ai200AzureAiDeveloperAssociate,
  [smbCybersecurityEssentials.slug]: smbCybersecurityEssentials,
  [smbIncidentResponsePlaybook.slug]: smbIncidentResponsePlaybook,
  [smbCybersecurityAwareness.slug]: smbCybersecurityAwareness,
  [smbCybersecurityRiskAwarenessWorkshop.slug]: smbCybersecurityRiskAwarenessWorkshop,
  [smbCybersecurityDataProtectionStrategies.slug]: smbCybersecurityDataProtectionStrategies,
  [ai300MlOpsEngineerAssociate.slug]: ai300MlOpsEngineerAssociate,
  [sc500CloudAndAiSecurityEngineer.slug]: sc500CloudAndAiSecurityEngineer,
  [sharepointCopilotInADay.slug]: sharepointCopilotInADay,
  [sharepointSiteOwners.slug]: sharepointSiteOwners,
  [sharepointSiteMembers.slug]: sharepointSiteMembers,
  [sharepointInformationArchitect.slug]: sharepointInformationArchitect,
  [sharepointCopilotReadinessFoundation.slug]: sharepointCopilotReadinessFoundation,
  [copilotFoundationsWave12.slug]: copilotFoundationsWave12,
  [copilotWave3AgenticAi.slug]: copilotWave3AgenticAi,
  [copilotGovernanceCompliance.slug]: copilotGovernanceCompliance,
  [copilotSecurityRoadmapEssentialEight.slug]: copilotSecurityRoadmapEssentialEight,
  [sc300IdentityAccessAdministrator.slug]: sc300IdentityAccessAdministrator,
  [conditionalAccessWorkshop.slug]: conditionalAccessWorkshop,
  [securingActiveDirectory.slug]: securingActiveDirectory,
  [hybridIdentityWorkshop.slug]: hybridIdentityWorkshop,
  [smbEssentialEightStarter.slug]: smbEssentialEightStarter,
  [cyberWardensUplift.slug]: cyberWardensUplift,
  [purviewRetentionAtScale.slug]: purviewRetentionAtScale,
  [purviewForCopilot.slug]: purviewForCopilot,
  [purviewInADayExecutive.slug]: purviewInADayExecutive,
  [purviewDataProtectionPractitioners.slug]: purviewDataProtectionPractitioners,
  [purviewInsiderRiskCommsCompliance.slug]: purviewInsiderRiskCommsCompliance,
  [purviewEnterpriseArchitecture.slug]: purviewEnterpriseArchitecture,
  [purviewEndpointSecurity.slug]: purviewEndpointSecurity,
  [purviewCommunicationCompliance.slug]: purviewCommunicationCompliance,
  [aiForFinanceM365.slug]: aiForFinanceM365,
  [aiForHealthcareM365.slug]: aiForHealthcareM365,
  [aiForHrM365.slug]: aiForHrM365,
  [aiForAccountingM365.slug]: aiForAccountingM365,
  [aiForLogisticsM365.slug]: aiForLogisticsM365,
  [sc100CybersecurityArchitectExpert.slug]: sc100CybersecurityArchitectExpert,
  [sc200SecurityOperationsAnalyst.slug]: sc200SecurityOperationsAnalyst,
  [sc400InformationProtectionAdministrator.slug]: sc400InformationProtectionAdministrator,
  [ms102Microsoft365Administrator.slug]: ms102Microsoft365Administrator,
  [detectingActiveDirectoryCompromise.slug]: detectingActiveDirectoryCompromise,
  [entraIdHardeningIdentityProtection.slug]: entraIdHardeningIdentityProtection,
  [defenderForCloudAppsSessionPolicies.slug]: defenderForCloudAppsSessionPolicies,

  // AI Quick Start family (#317)
  [promptEngineeringBasics.slug]: promptEngineeringBasics,
  [aiQuickStartHr.slug]: aiQuickStartHr,
  [aiQuickStartExecutiveAssistants.slug]: aiQuickStartExecutiveAssistants,
  [aiQuickStartSmallBusiness.slug]: aiQuickStartSmallBusiness,
};

// Build catalogCourses array - same structure as before
export const catalogCourses = Object.values(coursesData).map(course => ({
  id: course.id,
  slug: course.slug,
  title: course.title,
  duration: course.duration,
  students: course.students,
  level: course.level,
  image: course.image,
  description: course.shortDescription,
  organization: course.organization || 'EDUC4TE',
  featured: course.featured || false
}));
